<div class="booking">
  <div class="subheader" style="margin-bottom: 1.25rem;">
    <ng-container i18n>Booking Information</ng-container>
  </div>
  <div class="booking_information_card">
    <div class="section_1" *ngFor="let b of selectedBeds">
      <div *ngFor="let r of b.rates">
        <div style="font-size: 15px">
          {{r.count + '&nbsp;' + (r.count > 1 ? 'beds' : 'bed')}}
        </div>
        <div class="text medium">
          {{b.room.name}}
        </div>
        <div style="font-size: 15px">
          {{(b.room.rates[r.rateType].price * r.count) | currency : (currency | async).code}} x {{numNights}} {{numNights > 1 ? 'nights' : 'night'}}
        </div>
      </div>
    </div>
    <div class="section_1" *ngIf="!selectedBeds.length">
      <div style="font-size: 15px">
        {{''}}
      </div>
      <div class="text medium">
        <ng-container i18n> Choose your room</ng-container>
      </div>
      <div style="font-size: 15px">
        {{''}}
      </div>
    </div>
    <div class="section_2" style="font-size: 15px">
      <div>
        <ng-container i18n>Total</ng-container>
      </div>
      <div>
        {{total | currency: (currency | async)?.code}}
      </div>
    </div>
    <button class="section_4 text medium" (click)="lockBooking()" [disabled]="!selectedBeds?.length || locking" [ngClass]="{'disabled': !selectedBeds?.length || locking}">
      <ng-container i18n>Book Now</ng-container>
    </button>

  </div>
</div>
